import{useEffect}from"react";const useLifecycles=(mount,unmount)=>{useEffect(()=>(mount&&mount(),()=>{unmount&&unmount()}),[])};export default useLifecycles;